<!-- Generated template for the NoConnectionComponent component -->
<ion-title text-center ion-text color="white">
  {{ 'No Internet Connection' }}
</ion-title>